import { FC } from 'react';

import { Box, Tezos } from '@versumstudios/ui';

interface IPriceComponent {
  value: number;
}

export const PriceComponent: FC<IPriceComponent> = ({ value }) => (
  <Box css={{ fontSize: 14, color: '$secondaryFill' }}>
    {value}
    <Tezos />
  </Box>
);
